import { urlCreateSessionDOC24NoProd, urlCreateSessionDOC24Prod } from '../../actions/urls';
import { apiManagerRequest } from '../../axios';
import { CLIENT } from '../../constants/doc24';
import { openModalError } from '../../utils/modals';
import Session from '../../utils/session';
import { safeParseJSON } from '../../utils/utils';

class Doc24Service {
  static #alert = {
    [CLIENT.CMA]:
      'No se pudo ingresar a las videoconsultas en espera, por favor intente nuevamente en unos minutos. Si el error persiste, contacte a sistemas.',
    [CLIENT.MEDICAL_POINT]:
      'No se pudo ingresar a la agenda, por favor intente nuevamente en unos minutos. Si el error persiste, contacte a sistemas.',
  };
  static #subject = {
    [CLIENT.CMA]: 'Error al acceder a las videoconsultas en espera DOC 24',
    [CLIENT.MEDICAL_POINT]: 'Error al acceder a la agenda DOC 24',
  };
  static #section = {
    [CLIENT.CMA]: 'Videoconsultas en espera',
    [CLIENT.MEDICAL_POINT]: 'Agenda de Turnos',
  };

  static #showErrorAlert(client) {
    openModalError({
      title: 'Error',
      children: Doc24Service.#alert[client],
      size: 'lg',
    });
  }

  static async #sendEmailByDoc24Error({
    practitionerId,
    name,
    client,
    error = 'Error desconocido',
  }) {
    const subject = Doc24Service.#subject[client];
    const section = Doc24Service.#section[client];

    const emailData = {
      to: 'TurneraDigital@swissmedical.com.ar',
      subject,
      template: 'Prest_error_Doc24.htm',
      custom: [
        {
          name: 'content',
          value: `El prestador N° ${practitionerId} ${name} no pudo ingresar a la sección ${section} desde la Web de Prestadores, la página arroja un error que no le permite avanzar. Error: ${error}`,
        },
      ],
    };
    try {
      apiManagerRequest.post(urlErrorByDoc24, emailData);
    } catch (e) {
      console.log('Error al enviar el email', e);
    }
  }

  static async createSessionDOC24(practitionerId, email, client) {
    const name = Session.getAuth()?.modelEspecifico?.nombrePrestador ?? '';
    try {
      const finalUrl =
        window.REACT_APP_ENV !== 'prod' ? urlCreateSessionDOC24NoProd : urlCreateSessionDOC24Prod;
      const response = await apiManagerRequest.post(finalUrl, {
        idPrestador: practitionerId,
        email,
        client,
      });
      if (response.status !== 200) {
        Doc24Service.#sendEmailByDoc24Error({ practitionerId, name, client });
        return Doc24Service.#showErrorAlert(client);
      }

      const deeplink = response.data?.data?.deeplink;

      if (!deeplink) {
        return Doc24Service.#showErrorAlert(client);
      }

      if (client === CLIENT.CMA) {
        window.open(deeplink, '_blank');
        return;
      }

      window.location.href = deeplink;
    } catch (e) {
      const obj = safeParseJSON(e?.response?.data?.message);
      let error = 'Error desconocido';
      if (obj && typeof obj === 'object' && obj?.mensaje) {
        error = obj?.mensaje;
      }
      Doc24Service.#sendEmailByDoc24Error({ practitionerId, name, client, error });
      Doc24Service.#showErrorAlert(client);
    }
  }
}

export default Doc24Service;
